import superAdminApi from "./superAdminApi";
import { loaderService } from "./loaderService";

class SuperAdminAuthService {
  async login(email, password) {
    loaderService.show();
    try {
      const res = await superAdminApi.post("/super-admin/login", { email, password });
      const body = res?.data || {};
      const data = body?.data || body;
      return {
        token: data?.token ?? null,
        admin: data?.admin ?? null,
        sessionType: data?.sessionType ?? "SUPER_ADMIN",
        message: body?.message ?? "",
        success: !!body?.success,
      };
    } finally {
      loaderService.hide();
    }
  }

  async me() {
    const res = await superAdminApi.get("/super-admin/me");
    return res?.data?.data ?? res?.data;
  }

  async logout() {
    try {
      await superAdminApi.post("/super-admin/logout");
    } catch {
      // clear local session even if API fails
    }
  }

  async getDashboard() {
    const res = await superAdminApi.get("/super-admin/dashboard");
    return res?.data?.data ?? res?.data;
  }
}

export default new SuperAdminAuthService();
